import { useState } from "react";
import { toast } from "sonner";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/api";
import { MapPin, Mail } from "lucide-react";

export default function ContactSection() {
  const [form, setForm] = useState({ email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.message) { toast.error("Te rugăm completează toate câmpurile."); return; }
    setSending(true);
    try {
      const res = await api.contact({ ...form, name: "" });
      toast.success(res.message);
      setForm({ email: "", message: "" });
    } catch { toast.error("A apărut o eroare. Încearcă din nou."); }
    setSending(false);
  };

  return (
    <section id="contact" data-testid="contact-section" className="py-24 lg:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-16">
        <div>
          <Reveal>
            <p className="eyebrow text-[#B0803F] mb-4 font-semibold">Contact</p>
            <h2 className="font-serif font-medium text-4xl sm:text-5xl text-ink leading-tight" style={{ textShadow: "0 1px 1px rgba(42,36,33,0.08)" }}>Hai să vorbim</h2>
            <p className="text-ink mt-6 leading-relaxed max-w-md">
              Ai o întrebare despre creațiile noastre sau dorești o consultație olfactivă privată? Echipa ORÉLIE îți stă la dispoziție.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 space-y-5">
              {[
                { Icon: MapPin, txt: "Calea Rahovei, București, România", href: null },
                { Icon: Mail, txt: "orelieorelie30@gmail.com", href: "mailto:orelieorelie30@gmail.com" },
              ].map(({ Icon, txt, href }) => {
                const inner = (
                  <>
                    <span className="w-10 h-10 flex items-center justify-center border border-mocha/50 bg-mocha/10 text-[#B0803F]"><Icon size={18} strokeWidth={1.5} /></span>
                    <span className="text-sm">{txt}</span>
                  </>
                );
                return href ? (
                  <a key={txt} href={href} data-testid="contact-email-link" className="flex items-center gap-4 text-ink font-medium hover:text-mocha-dark transition-colors">{inner}</a>
                ) : (
                  <div key={txt} className="flex items-center gap-4 text-ink font-medium">{inner}</div>
                );
              })}
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <form onSubmit={submit} data-testid="contact-form" className="bg-surface border border-line/70 p-8 space-y-5">
            <div>
              <label className="eyebrow text-[0.6rem] block mb-2">E-mail</label>
              <input data-testid="contact-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full bg-cream border border-line px-4 py-3 text-ink outline-none focus:border-mocha-dark transition-colors" placeholder="adresa@email.com" />
            </div>
            <div>
              <label className="eyebrow text-[0.6rem] block mb-2">Mesaj</label>
              <textarea data-testid="contact-message" rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
                className="w-full bg-cream border border-line px-4 py-3 text-ink outline-none focus:border-mocha-dark transition-colors resize-none" placeholder="Mesajul tău..." />
            </div>
            <button data-testid="contact-submit" disabled={sending}
              className="w-full py-4 bg-ink text-cream text-xs uppercase tracking-[0.25em] hover:bg-mocha-dark transition-all duration-500 disabled:opacity-60">
              {sending ? "Se trimite..." : "Trimite mesajul"}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
